import i18n from 'i18next'; // wait, it should be import i18n from 'i18next'
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // ── Navbar ──
      "Home": "Home",
      "About": "About",
      "Departments": "Departments",
      "Administration": "Administration",
      "Accounts": "Accounts",
      "Agriculture": "Agriculture",
      "Manufacturing": "Manufacturing",
      "Cane Development": "Cane Development",
      "Power Cogeneration": "Power Cogeneration",
      "Labour Time Office": "Labour Time Office",
      "Engineering": "Engineering",
      "Environment": "Environment",
      "Soil Testing Laboratory": "Soil Testing Laboratory",
      "Products": "Products",
      "Our Strengths": "Our Strengths",
      "Sustainability": "Sustainability",
      "Awards": "Awards",
      "Gallery": "Gallery",
      "News": "News",
      "Careers": "Careers",
      "Downloads": "Downloads",
      "Contact": "Contact",
      "Honors & Awards": "Honors & Awards",

      // ── General Actions / Buttons ──
      "Learn More": "Learn More",
      "Learn More About Us": "Learn More About Us",
      "Explore Our Products": "Explore Our Products",
      "Our Heritage": "Our Heritage",
      "Inquire Sales Team": "Inquire Sales Team",
      "Browse All Products": "Browse All Products",
      "Apply Now": "Apply Now",
      "Send Message": "Send Message",
      "Back to catalog": "Back to catalog",
      "Back to Media Center": "Back to Media Center",
      "Read Full Story": "Read Full Story",
      "Read Story": "Read Story",
      "Details": "Details",
      "View Details": "View Details",
      "Get Directions": "Get Directions",

      //      // ── Headings & Titles ──
      "What We Do": "What We Do",
      "Our Core Operations": "Our Core Operations",
      "Governance": "Governance",
      "Board of Directors": "Board of Directors",
      "Our Range": "Our Range",
      "Premium Products": "Premium Products",
      "Visual Tour": "Visual Tour",
      "Visual Gallery": "Visual Gallery",
      "Newsroom": "Newsroom",
      "Latest Updates": "Latest Updates",
      "Partner with a Sustainable Future": "Partner with a Sustainable Future",
      "Contact Factory": "Contact Factory",

      "Our Strengths & Vision": "Our Strengths & Vision",
      "Discover the core pillars, modern infrastructure, and operational excellence that drive our success.": "Discover the core pillars, modern infrastructure, and operational excellence that drive our success.",
      "Welcome to Sangram Cane Agro": "Welcome to Sangram Cane Agro",
      "Founder's Address": "Founder's Address",
      "Leadership Statement": "Leadership Statement",
      "From the Chairman's Desk": "From the Chairman's Desk",
      "From the Chairman's": "From the Chairman's",
      "Desk": "Desk",
      "Founder & Chairman": "Founder & Chairman",
      "Late. Vithhalrao ( Bapusaheb ) Yesugade": "Late. Vithhalrao ( Bapusaheb ) Yesugade",
      "Late. Vithhalrao (Bapusaheb) Yesugade": "Late. Vithhalrao (Bapusaheb) Yesugade",
      "Late. Vitthalrao (Bapusaheb) Yesugade": "Late. Vitthalrao (Bapusaheb) Yesugade",
      "Registered Office": "Registered Office",
      "Sangram Bhawan": "Sangram Bhawan",
      "Plot No. 187/1, Tasgaon-Karad Road,": "Plot No. 187/1, Tasgaon-Karad Road,",
      "Industrial Estate, Palus - 416310": "Industrial Estate, Palus - 416310",
      "Tal. Palus, Dist. Sangli": "Tal. Palus, Dist. Sangli",
      "Factory & Works": "Factory & Works",
      "Sangram Cane Agro Limited": "Sangram Cane Agro Limited",
      "Bhilwadi-Sukhwadi Road,": "Bhilwadi-Sukhwadi Road,",
      "Bhilwadi - 416303": "Bhilwadi - 416303",
      "Quick Links": "Quick Links",
      "About Us": "About Us",
      "Leading the way in sustainable sugar manufacturing and renewable energy. Committed to farmer prosperity and environmental excellence.": "Leading the way in sustainable sugar manufacturing and renewable energy. Committed to farmer prosperity and environmental excellence.",
      "© 2026 Sangram Cane Agro Limited. All Rights Reserved.": "© 2026 Sangram Cane Agro Limited. All Rights Reserved.",
      "Designed & Developed by": "Designed & Developed by",

      "Sangram Cane Agro": "Sangram Cane Agro",
      "Purity You Can Trust, Sweetness You Can Believe In. 100% Natural Jaggery & Jaggery Powder – From Our Farms to Your Kitchen, delivering pure, chemical-free sweetness in every bite.": "Purity You Can Trust, Sweetness You Can Believe In. 100% Natural Jaggery & Jaggery Powder – From Our Farms to Your Kitchen, delivering pure, chemical-free sweetness in every bite.",
      "Our Legacy & History": "Our Legacy & History",
      "A Heritage of Innovation & Prosperity": "A Heritage of Innovation & Prosperity",
      "Trust, Quality &": "Trust, Quality &",
      "Prosperity Journey": "Prosperity Journey",
      "Pure Jaggery, Empowered": "Pure Jaggery, Empowered",
      "Farmers, Sustainable Agriculture": "Farmers, Sustainable Agriculture",
      "Sangram Cane Agro is a farmer-owned and farmer-driven company committed to supporting the agricultural community while delivering premium-quality natural products. Using carefully selected sugarcane grown in the fertile fields of Sangli district, we produce Natural Jaggery, Jaggery Powder, Bagasse Briquettes, and Organic Fertilizer by combining traditional practices with modern processing standards. Every stage of production is carried out with strict hygiene, quality control, and food safety measures to ensure that our customers receive 100% natural, chemical-free, and nutritious products.": "Sangram Cane Agro is a farmer-owned and farmer-driven company committed to supporting the agricultural community while delivering premium-quality natural products. Using carefully selected sugarcane grown in the fertile fields of Sangli district, we produce Natural Jaggery, Jaggery Powder, Bagasse Briquettes, and Organic Fertilizer by combining traditional practices with modern processing standards. Every stage of production is carried out with strict hygiene, quality control, and food safety measures to ensure that our customers receive 100% natural, chemical-free, and nutritious products.",
      "Our mission is to provide farmers with fair value for their hard work while offering consumers pure, healthy, and authentic sweetness they can trust. We are guided by four core values—quality, transparency, sustainability, and customer satisfaction.": "Our mission is to provide farmers with fair value for their hard work while offering consumers pure, healthy, and authentic sweetness they can trust. We are guided by four core values—quality, transparency, sustainability, and customer satisfaction.",

      // ── Stats ──
      "Farmers Connected": "Farmers Connected",
      "Tons of Sugar / Year": "Tons of Sugar / Year",
      "Ethanol Capacity (L)": "Ethanol Capacity (L)",
      "Power Generated (MW)": "Power Generated (MW)",
      "Export Countries": "Export Countries",
      "Founded": "Founded",
      "TCD Capacity": "TCD Capacity",
      "Farmers": "Farmers",
    }
  },
  mr: {
    translation: {
      "Sangram Cane Agro": "संग्राम केन ॲग्रो",
      "Purity You Can Trust, Sweetness You Can Believe In. 100% Natural Jaggery & Jaggery Powder – From Our Farms to Your Kitchen, delivering pure, chemical-free sweetness in every bite.": "शुद्धतेची आणि विश्वासाची हमी १००% नैसर्गिक गुळ आणि जागरी पावडर – शेतातून थेट तुमच्या स्वयंपाकघरापर्यंत, प्रत्येक घासात शुद्ध गोडव्याची खात्री.",
      "Our Legacy & History": "आमचा वारसा आणि इतिहास",
      "A Heritage of Innovation & Prosperity": "नाविन्यता आणि समृद्धीचा वारसा",
      "Sangram Cane Agro is a farmer-owned and farmer-driven company committed to supporting the agricultural community while delivering premium-quality natural products. Using carefully selected sugarcane grown in the fertile fields of Sangli district, we produce Natural Jaggery, Jaggery Powder, Bagasse Briquettes, and Organic Fertilizer by combining traditional practices with modern processing standards. Every stage of production is carried out with strict hygiene, quality control, and food safety measures to ensure that our customers receive 100% natural, chemical-free, and nutritious products.": "संग्राम केन ॲग्रो ही शेतकरी चालवणारी आणि शेतकऱ्यांच्या हिताला सर्वोच्च प्राधान्य देणारी कंपनी आहे. आम्ही सांगली जिल्ह्यातील सुपीक शेतांमध्ये पिकवलेल्या दर्जेदार ऊसापासून पारंपरिक पद्धतीची शुद्धता आणि आधुनिक तंत्रज्ञानाची सुरक्षितता यांचा संगम साधत नैसर्गिक गुळ, जागरी पावडर, बगास ब्रिकेट्स आणि सेंद्रिय खत यांचे उत्पादन करतो. उत्पादनाच्या प्रत्येक टप्प्यावर स्वच्छता, गुणवत्ता आणि अन्नसुरक्षा मानकांचे काटेकोर पालन केले जाते, ज्यामुळे ग्राहकांपर्यंत 100% नैसर्गिक, पौष्टिक आणि केमिकलविरहित उत्पादने पोहोचतात.",
      "Our mission is to provide farmers with fair value for their hard work while offering consumers pure, healthy, and authentic sweetness they can trust. We are guided by four core values—quality, transparency, sustainability, and customer satisfaction.": "आमचे ध्येय म्हणजे शेतकऱ्यांना त्यांच्या कष्टाचे योग्य मूल्य मिळवून देणे आणि ग्राहकांना विश्वासार्ह, शुद्ध व आरोग्यदायी गोडवा उपलब्ध करून देणे. गुणवत्ता, पारदर्शकता, पर्यावरणपूरक उत्पादन प्रक्रिया आणि ग्राहकांचे समाधान ही आमच्या कार्याची चार प्रमुख तत्त्वे आहेत.",
      // ── Navbar ──
      "Home": "मुख्यपृष्ठ",
      "About": "आमच्याबद्दल",
      "Departments": "विभाग",
      "Administration": "प्रशासन विभाग",
      "Accounts": "लेखा विभाग",
      "Agriculture": "कृषी विभाग",
      "Manufacturing": "उत्पादन विभाग",
      "Cane Development": "ऊस विकास विभाग",
      "Power Cogeneration": "सह-वीज निर्मिती विभाग",
      "Labour Time Office": "कामगार वेळ कार्यालय",
      "Engineering": "अभियांत्रिकी विभाग",
      "Environment": "पर्यावरण विभाग",
      "Soil Testing Laboratory": "माती परीक्षण प्रयोगशाळा",
      "Products": "उत्पादने",
      "Our Strengths": "आमची वैशिष्ट्ये",
      "Sustainability": "शाश्वतता",
      "Awards": "पुरस्कार",
      "Gallery": "गॅलरी",
      "News": "बातम्या",
      "Careers": "करिअर",
      "Downloads": "डाउनलोड",
      "Contact": "संपर्क",
      "Honors & Awards": "सन्मान आणि पुरस्कार",

      // ── General Actions / Buttons ──
      "Learn More": "अधिक जाणून घ्या",
      "Learn More About Us": "आमच्याबद्दल अधिक जाणून घ्या",
      "Explore Our Products": "आमची उत्पादने पहा",
      "Our Heritage": "आमचा वारसा",
      "Inquire Sales Team": "विक्री संघाकडे चौकशी करा",
      "Browse All Products": "सर्व उत्पादने पहा",
      "Apply Now": "आत्ताच अर्ज करा",
      "Send Message": "संदेश पाठवा",
      "Back to catalog": "कॅटलॉगवर परत जा",
      "Back to Media Center": "मीडिया सेंटरवर परत जा",
      "Read Full Story": "पूर्ण बातमी वाचा",
      "Read Story": "बातमी वाचा",
      "Details": "तपशील",
      "View Details": "तपशील पहा",
      "Get Directions": "दिशा मिळवा",

      // ── Headings ──
      "What We Do": "आम्ही काय करतो",
      "Our Core Operations": "आमचे मुख्य ऑपरेशन्स",
      "Governance": "प्रशासन",
      "Board of Directors": "संचालक मंडळ",
      "Our Range": "उत्पादन विभाग",
      "Premium Products": "आमची गुणवत्तेची उत्पादने",
      "Product Division": "उत्पादन विभाग",
      "Our Quality Products": "आमची गुणवत्तेची उत्पादने",
      "Visual Tour": "आमचा प्रवास",
      "Visual Gallery": "कारखान्याची काही क्षणचित्रे",
      "Our Journey": "आमचा प्रवास",
      "Moments & Highlights": "कारखान्याची काही क्षणचित्रे",
      "Latest Updates": "नवीनतम घडामोडी",
      "Contact Factory": "कारखान्याशी संपर्क साधा",
      "Contact Our Factory": "कारखान्याशी संपर्क साधा",
      "From the Founder's Desk": "संस्थापकांच्या मनोगतातून",
      "View Founder Address": "संस्थापकांचा पूर्ण संदेश पहा",
      "View Chairman Address": "संस्थापकांचा पूर्ण संदेश पहा",
      "अध्यक्षांचे भाषण पहा": "संस्थापकांचा पूर्ण संदेश पहा",
      "Purpose & Strategic Focus": "उद्देश आणि धोरणात्मक फोकस",
      "Pure Jaggery, Empowered Farmers, Sustainable Agriculture": "शुद्ध गुळ, सशक्त शेतकरी, शाश्वत शेती",
      "Trust, Quality &": "विश्वास, गुणवत्ता आणि",
      "Prosperity Journey": "समृद्धीचा प्रवास.",
      "Pure Jaggery, Empowered": "शुद्ध गुळ, सशक्त",
      "Farmers, Sustainable Agriculture": "शेतकरी, शाश्वत शेती",
      "We produce premium-quality chemical-free jaggery, jaggery powder, and organic fertilizer using modern technology and natural processes. Our goal is to improve sugarcane productivity, support farmers, and promote sustainable agriculture.": "आम्ही आधुनिक तंत्रज्ञान आणि नैसर्गिक प्रक्रियेद्वारे उच्च दर्जाचा रसायनमुक्त गुळ, गुळ पावडर आणि सेंद्रिय खताची निर्मिती करतो. शेतकऱ्यांच्या ऊस उत्पादनात वाढ, गुणवत्तापूर्ण उत्पादन आणि पर्यावरणपूरक उद्योग उभारणे हेच आमचे ध्येय आहे.",
      "Our Mission": "आमचे मिशन",
      "To manufacture premium-quality jaggery, jaggery powder, and organic fertilizer through advanced technology and farmer-centric practices while delivering safe, natural, and reliable products.": "आधुनिक तंत्रज्ञान, गुणवत्तापूर्ण प्रक्रिया आणि शेतकरी-केंद्रित सेवांद्वारे उत्कृष्ट दर्जाचा गुळ, गुळ पावडर व सेंद्रिय खत तयार करून ग्राहकांचा विश्वास संपादन करणे.",
      "Quality First": "गुणवत्ता प्रथम",
      "Farmer Prosperity": "शेतकरी समृद्धी",
      "Natural Products": "नैसर्गिक उत्पादने",
      "Our Vision": "आमची दृष्टी",
      "To become India's most trusted producer of natural jaggery, jaggery powder, and organic fertilizer while creating sustainable value for farmers, customers, and the environment.": "उच्च दर्जाचा नैसर्गिक गुळ, गुळ पावडर आणि सेंद्रिय खत निर्मितीत देशातील अग्रगण्य उद्योग बनून शेतकरी, ग्राहक आणि पर्यावरणासाठी शाश्वत मूल्य निर्माण करणे.",
      "Sustainable Agriculture": "शाश्वत शेती",
      "Natural Quality": "नैसर्गिक गुणवत्ता",
      "Farmer Growth": "शेतकरी विकास",
      "Our Principles": "आमची तत्त्वे",
      "Core Values": "मूल्ये",
      "Delivering superior quality and food safety in every jaggery and jaggery powder product.": "प्रत्येक गुळ व गुळ पावडर उत्पादनामध्ये सर्वोच्च गुणवत्ता आणि सुरक्षितता सुनिश्चित करणे.",
      "Supporting farmers through modern farming guidance, planning, and reliable services.": "आधुनिक शेती मार्गदर्शन, योग्य नियोजन आणि विश्वासार्ह सेवांद्वारे शेतकऱ्यांचा विकास.",
      "Innovation": "नवकल्पना",
      "Continuously adopting modern technology to improve quality, productivity, and efficiency.": "उत्पादन क्षमता, गुणवत्ता आणि कार्यक्षमतेसाठी आधुनिक तंत्रज्ञानाचा सातत्याने अवलंब.",
      "Environmental Responsibility": "पर्यावरण संरक्षण",
      "Promoting eco-friendly manufacturing through organic fertilizer production and sustainable resource utilization.": "सेंद्रिय खत निर्मिती, संसाधनांचा कार्यक्षम वापर आणि पर्यावरणपूरक उत्पादन प्रक्रियेस प्राधान्य.",
      // ── Page Headers ──
      "About Sangram Cane Agro": "आमच्याबद्दल",
      "Legacy • Quality • Trust": "आमचा वारसा • गुणवत्ता • विश्वास",
      "Our Premium Products": "आमची उत्पादने",
      "Purity You Can Trust": "शुद्धता आणि गुणवत्तेची हमी",
      "Factory Gallery": "आनंदाची काही क्षणचित्रे",
      "A Visual Journey of Excellence": "आमच्या कार्याची दृश्य सफर",
      "Newsroom": "बातम्या व उपक्रम",
      "Latest News & Corporate Updates": "ताज्या घडामोडी आणि घोषणा",
      "Download Center": "डाउनलोड केंद्र",
      "Important Resources & Documents": "महत्त्वाची कागदपत्रे आणि संसाधने",

      // ── Specific Custom Marathi Translations ──
      "Our Strengths & Vision": "संग्राम केन ॲग्रोची वैशिष्ट्ये व ध्येय",
      "Discover the core pillars, modern infrastructure, and operational excellence that drive our success.": "आधुनिक तंत्रज्ञान, पारदर्शक व्यवस्थापन आणि शेतकरी-केंद्रित विकासाच्या माध्यमातून समृद्ध भविष्य घडविण्याचा आमचा संकल्प.",
      "Welcome to Sangram Cane Agro": "संग्राम केन ॲग्रो मध्ये आपले स्वागत आहे",
      "Founder's Address": "संस्थापकांचे मनोगत",
      "Leadership Statement": "आमचे प्रेरणास्थान",
      "From the Chairman's Desk": "संस्थापकांच्या मनोगतातून",
      "From the Chairman's": "संस्थापकांच्या",
      "Desk": "मनोगतातून",
      "Founder & Chairman": "संस्थापक - संग्राम उद्योग समुह",
      "Late. Vithhalrao ( Bapusaheb ) Yesugade": "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
      "Late. Vithhalrao (Bapusaheb) Yesugade": "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
      "Late. Vitthalrao (Bapusaheb) Yesugade": "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
      "Vitthalrao Yesugade": "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
      "कै. विठ्ठलराव (बापूसाहेब) येसुगडे": "स्व. विठ्ठलराव (बापूसो) बबनराव येसुगडे",
      "संस्थापक आणि अध्यक्ष": "संस्थापक - संग्राम उद्योग समुह",
      "Director": "संचालक",
      "DIRECTOR": "संचालक",
      "Technical Director": "तांत्रिक संचालक",
      "TECHNICAL DIRECTOR": "तांत्रिक संचालक",
      "Executive Director": "कार्यकारी संचालक",
      "Managing Director": "व्यवस्थापकीय संचालक",
      "दिग्दर्शक": "संचालक",

      // ── Footer Translations ──
      "Leading the way in sustainable sugar manufacturing and renewable energy. Committed to farmer prosperity and environmental excellence.": "शाश्वत साखर उत्पादन आणि अक्षय ऊर्जेच्या क्षेत्रात आघाडीवर. शेतकरी समृद्धी आणि पर्यावरणीय उत्कृष्टतेसाठी कटिबद्ध.",
      "Registered Office": "नोंदणीकृत कार्यालय",
      "Sangram Bhawan": "संग्राम भवन",
      "Plot No. 187/1, Tasgaon-Karad Road,": "प्लॉट नं. १८७/१, तासगाव-कराड रोड,",
      "Industrial Estate, Palus - 416310": "इंडस्ट्रियल इस्टेट, पलूस - ४१६३१०",
      "Tal. Palus, Dist. Sangli": "ता. पलूस, जि. सांगली",
      "Factory & Works": "कारखाना व प्लांट",
      "Sangram Cane Agro Limited": "संग्राम केन ॲग्रो लिमिटेड",
      "Bhilwadi-Sukhwadi Road,": "भिलवडी-सुखवाडी रोड,",
      "Bhilwadi - 416303": "भिलवडी - ४१६३०३",
      "Quick Links": "महत्त्वाच्या लिंक्स",
      "About Us": "आमच्याबद्दल",
      "© 2026 Sangram Cane Agro Limited. All Rights Reserved.": "© २०२६ संग्राम केन ॲग्रो लिमिटेड. सर्व हक्क राखीव.",
      "Designed & Developed by": "डिझाइन आणि निर्मिती",

      // ── Stats ──
      "Farmers Connected": "जोडलेले शेतकरी",
      "Tons of Sugar / Year": "वार्षिक साखर उत्पादन (टन)",
      "Ethanol Capacity (L)": "इथेनॉल क्षमता (ली)",
      "Power Generated (MW)": "वीज निर्मिती (मेगावॅट)",
      "Export Countries": "निर्यात देश",
      "Founded": "स्थापना",
      "TCD Capacity": "टीसीडी क्षमता",
      "Farmers": "शेतकरी",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'mr', // Marathi by default
    fallbackLng: 'mr',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language || 'mr';
  if ((i18n.language || 'mr') === 'mr') {
    document.body.classList.add('lang-mr');
  }
}

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  if (typeof document !== 'undefined') {
    if (lng === 'mr') {
      document.body.classList.add('lang-mr');
    } else {
      document.body.classList.remove('lang-mr');
    }
  }
});

export default i18n;
